import { useState } from 'react';

export enum ProductDetailsSection {
  GRID = 'grid',
  DESCRIPTION = 'description',
  DETAILS = 'details',
  RELATED = 'related',
}

const useProductDetailsSections = () => {
  const [closedSectionIds, setClosedSectionIds] = useState<ReadonlySet<string>>(() => new Set());

  const isSectionOpen = (sectionId: string) => !closedSectionIds.has(sectionId);

  const toggleSection = (sectionId: string) => {
    setClosedSectionIds((currentIds) => {
      const nextIds = new Set(currentIds);

      if (nextIds.has(sectionId)) {
        nextIds.delete(sectionId);
      } else {
        nextIds.add(sectionId);
      }

      return nextIds;
    });
  };

  return { isSectionOpen, toggleSection };
};

export default useProductDetailsSections;
